import { SiteSimpleImage } from "../../../../commonComponents/inline/siteSimpleImage"

require("./ynet_pplus_magazine_site_signupForPodcast.less")

interface SignUpForPodcastProps {
    categoryId: string
    categoryIcon?:string
    followPodcastText?: string
    className?:string
}
interface PodcastShareLInks {
    google: string
    apple: string
    spotify: string
    youtube:string
}

declare let window: Window & {
    podcastsShareLinksList: any
}

export const SignUpForPodcast = (props: SignUpForPodcastProps) => {
    const { categoryId, followPodcastText, categoryIcon, className } = props
    const podcastsShareLinksList = typeof window !== "undefined" && window.podcastsShareLinksList;
    const categoryShareLinks = podcastsShareLinksList && podcastsShareLinksList[categoryId] ? podcastsShareLinksList[categoryId] as PodcastShareLInks : null;

    return (
        <div className={`signup-for-podcast ${className ? className : ""}`} style={!categoryShareLinks ? { display: 'none' } : {}}>
           {categoryIcon ? <SiteSimpleImage src={categoryIcon} className="category-icon" /> : null}
            <div className="signup-for-podcast-title-rpf">{followPodcastText ? followPodcastText : "עקבו אחר הפודקאסט"}</div>
            <div className="signup-for-podcast-buttons">
                <a className="spotify-signup-btn podcast-signup-btn" href={categoryShareLinks ? categoryShareLinks.spotify : ""} target="_blank" />
                <a className="apple-podcasts-signup-btn podcast-signup-btn" href={categoryShareLinks ? categoryShareLinks.apple : ""} target="_blank" />
               { categoryShareLinks && categoryShareLinks.youtube ? 
               <a className="youtube-podcasts-signup-btn podcast-signup-btn" href={categoryShareLinks.youtube} target="_blank" /> 
               : <a className="youtube-podcasts-signup-btn podcast-signup-btn" style={{cursor:"inherit"}}  />}
            </div>
        </div>
    )
}

SignUpForPodcast.siteScriptName = "SignUpForPodcast"